import actions from './actions'
import getters from './getters'
import getBaseUrl from '@/helpers/getBaseUrl'
import pathField from '@/helpers/pathField'

export default {
  namespaced: true,
  state: {
    api: {
      host: getBaseUrl(),
      admin: `${getBaseUrl()}/api/`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    },
    blogPage: {
      // filters: [
      //   {
      //     id: 2,
      //     title: 'Jeppar á íslandi'
      //   },
      //   {
      //     id: 3,
      //     title: 'Rafbílar'
      //   },
      //   {
      //     id: 4,
      //     title: 'Myndband dagsins'
      //   }
      // ],
      posts: [],
      lastAddedPosts: []
    },
    limit: 10,
    loading: false,
    simplePage: {},
    similarPosts: [],

    // Static data
    category: [
      {
        id: 1,
        title: 'Fréttir',
        url: 'frettir'
      },
      /*{
        id: 2,
        title: 'Viðburðir',
        url: 'vidburdir'
      },*/
      {
        id: 3,
        title: 'Reynsluakstur',
        url: 'reynsluakstur'
      }
    ],

    months: [
      'Janúar',
      'Febrúar',
      'Mars',
      'Apríl',
      'Maí',
      'Júní',
      'Júlí',
      'Ágúst',
      'September',
      'Október',
      'Nóvember',
      'Desember'
    ]
  },
  mutations: {
    SET_DATA (state, { field, data }) {
      // state[field] = data
      pathField(state, field, data)
    }
  },
  actions,
  getters
}
